import { HelpersService } from './../../services/tools/helpers.service';
import { ProveedoresGruposService } from './../../services/proveedores-grupos.service';
import { ProveedoresService } from './../../services/proveedores.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {Globals} from './../../services/tools/Globals.service';
declare let $;

@Component({
  selector: 'app-catalogo-proveedores-grupos',
  templateUrl: './catalogo-proveedores-grupos.component.html',
  styleUrls: ['./catalogo-proveedores-grupos.component.scss']
})
export class CatalogoProveedoresGruposComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  proveedoresGrupos: any[];
  proveedoresList: any[];
  proveedoresTipoList: any[];
  searchText: string = '';
  proveedoresGrupoSelected: any;
  proveedoresSelected: any[];
  proveedorToAdd: any;
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  filterByProveedor:any;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable:any = 'starting';
  exporting: any = false;
  proveedorFilter: any = {};
  statusToAdd:any={};


  constructor ( private proveedoresService: ProveedoresService,
                private proveedoresGruposService: ProveedoresGruposService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private globals: Globals) {

    // se colocó esto para que el this dentro de delete sea el del scope global
    this.deleteProveedoresGrupo = this.deleteProveedoresGrupo.bind(this);
    this.resetProveedoresGrupoSelected = this.resetProveedoresGrupoSelected.bind(this);
    this.getProveedoresGrupos();
    this.getProveedores();
    this.getTiposProveedor();
   }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  filtrarProveedoresGrupos() {
    this.goPage(1);

  }

  resetProveedoresGrupoSelected() {
    this.proveedoresGrupoSelected = undefined;
    this.proveedoresSelected = [];
    this.proveedorToAdd = undefined;
    this.errors = {};
  }

  startProveedoresGrupoSelected() {
    this.resetProveedoresGrupoSelected();
    this.proveedoresGrupoSelected = this.proveedoresGruposService.getDefaultSchedule();
    this.proveedorToAdd = undefined;
    this.proveedoresSelected = [];
  }

  selectProveedoresGrupos(proveedoresGrupo) {
    this.resetProveedoresGrupoSelected();
    const proveedoresGrupoCloned = JSON.parse(JSON.stringify( proveedoresGrupo ));
    this.proveedoresGrupoSelected = proveedoresGrupoCloned;
    const proveedores_elementos_cloned = JSON.parse(JSON.stringify( proveedoresGrupo.proveedores_elementos ));
    this.proveedoresSelected = proveedores_elementos_cloned;
  }

  SelectedProveedoresGruposClass(proveedor) {
    return (this.validatorService.required(this.proveedoresGrupoSelected) &&  this.proveedoresGrupoSelected.idProveedores_Grupos === proveedor.idProveedores_Grupos) ? 'active' : '';
  }

  searchProveedoresGrupos(page = null) {
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 0) {
      this.searchProcess = this.proveedoresGruposService.searchProveedoresGrupos(this.searchText, page)
          .subscribe(response => {
            const content = response.json().content;
            this.proveedoresGrupos = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.proveedoresGrupos.length > 0)? false: 'not_found';
          });
    } else {
      this.getProveedoresGrupos();
    }
  }

  getProveedores() {

    this.proveedoresService.getProveedorestoSelect()
      .subscribe(response => {
        let content = response.json().content;
        this.proveedoresList = content.proveedores;
      });
  }

  getTiposProveedor(){
    this.proveedoresService.getTiposProveedor()
      .subscribe(response => {
        let content = response.json().content;
        this.proveedoresTipoList = content;
      });
  }

  getProveedoresGrupos(page = null) {

    this.searchProcess = this.proveedoresGruposService.getProveedoresGrupos(page)
      .subscribe(response => {
        const content = response.json().content;

        console.log('content ', content);

        this.proveedoresGrupos = content.data;
        this.startPaginate(content);
        this.alterTable = (this.proveedoresGrupos.length > 0)? false: 'not_result';
        this.searchProcess = false;
      });
  }
  createProveedoresGrupo() {
    this.errors = [];

    this.proveedoresGrupoSelected.proveedores_elementos = this.proveedoresSelected;
    this.errors = this.proveedoresGruposService.validateProveedoresGrupo(this.proveedoresGrupoSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    console.log("entra");
    this.processing = true;
    this.proveedoresGruposService.createProveedoresGrupo(this.proveedoresGrupoSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el grupo'
          });
          this.proveedoresGrupoSelected.idProveedores_Grupos = respuesta.content.id;
          this.goPage(1);
        }
      }, error => {
        this.processing = false;
        // resolviendo errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el grupo, inténtelo más tarde'
          });
        }
      });
  }

  updateProveedoresGrupo() {
    this.errors = [];
    this.proveedoresGrupoSelected.proveedores_elementos = this.proveedoresSelected;
    this.errors = this.proveedoresGruposService.validateProveedoresGrupo(this.proveedoresGrupoSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.proveedoresGruposService.updateProveedoresGrupo(this.proveedoresGrupoSelected, this.proveedoresGrupoSelected.idProveedores_Grupos)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el grupo', 'success');
          this.goPage(this.currentPage);
        }
      }, error => {
        this.processing = false;
        // resolviendo errores 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notificationErrorDefault();
        }
      });
  }

  writePermission() {
    return this.proveedoresService.writePermission();
  }

  canExport() {
    return this.proveedoresGruposService.canExport();
  }

  confirmDeleteProveedoresGrupo() {
    this.confirmModal.open({
      'title': 'Eliminar grupo',
      'description': '¿Está seguro que desea eliminar este Grupo?',
      'callback': this.deleteProveedoresGrupo
    });
  }

  deleteProveedoresGrupo() {
    this.processing = true;
    this.proveedoresGruposService.deleteProveedoresGrupo(this.proveedoresGrupoSelected.idProveedores_Grupos)
      .subscribe(
        response => {
          const respuesta = response.json();
          this.processing = false;
          if (respuesta.success) {
            this.successModal.open({
              'title': '¡Éxito!',
              'description': 'Se ha eliminado correctamente el grupo seleccionado'
            });
            this.resetProveedoresGrupoSelected();
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;
          // resolviendo errores 403 y 500
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400) {
            this.errorModal.open({
              'title': 'Error',
              'description': error.json().content.group_exist
            });
          }

          if (error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar el grupo, inténtelo más tarde'
            });
          }
      });
  }

  export() {
    this.exporting = true;
    this.proveedoresGruposService.export(this.searchText)
      .subscribe((response) => {
        this.exporting = false;
      }, error => {
        // se resuelven los errores 403 y 500
        this.exporting = false;
        this.helperService.httpGlobalError(error);
      });
  }

  addProveedor() {
    this.proveedoresSelected.push({
      'proveedores': this.proveedorToAdd
    });
    this.proveedorToAdd = '';
  }


  removeProveedor(index) {
    this.proveedoresSelected.splice(index,1);
  }

  disabledAddProveedores() {
    const _this = this;

    if (!this.validatorService.required(this.proveedorToAdd)) {
      return true;
    }

    const found = this.proveedoresSelected.find(function(element) {
      return element.proveedores.idProveedores === _this.proveedorToAdd.idProveedores;
    });

    if (found) {
      return true;
    }

    return false;
  }

  setBackendErrors(errors: any[]) {
    const temp_errors = [];
    Object.keys(errors).forEach(function(key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  proveedoresGrupoSelectedWithId() {
    if (! this.proveedoresGrupoSelected) {
      return false;
    }

    return (this.validatorService.required(this.proveedoresGrupoSelected.idProveedores_Grupos));
  }

  cancelarProveedoresGrupoSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetProveedoresGrupoSelected
    });
  }

  getIntegrantesLista(list) {

    let nombres = '';
    const _this = this;

    list.forEach(function(element, key) {
      if (key > 0) {
        nombres = nombres + ', ';
      }

      nombres = nombres + element.proveedores.nombre;

    });

    return nombres;

  }

  // MODAL FUNCTIONS

  modalCallback(callback) {
    callback();
  }

  mainContainerClass() {
    return (this.mostrarListado) ? 'col-12' : 'offset-2 col-8';
  }

  mainTableClass() {
    return (this.mostrarListado) ? 'col-8' : 'col-4';
  }

  mainDetailsClass() {
    return (this.mostrarListado) ? 'col-4' : 'col-8';
  }

  startPaginate(content) {
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage() {
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.searchProveedoresGrupos(page);
    } else {
      this.getProveedoresGrupos(page);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-proveedores-grupos/catalogo-proveedores-grupos.component.ts